import PropTypes from 'prop-types';
import React from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';

import { propTypesLink } from '../../constants/Proptypes';
import {
  propTypesDropdown1,
  propTypesDropdown2,
  propTypesDropdown3,
  propTypesDropdown4,
} from '../Layout/Header/Header.proptypes';

import Button, { ButtonAppearance } from '../../../ui/Atoms/Button';
import Collapse, { CollapseAppearance } from '../../../ui/Atoms/Collapse';
import Dropdown from '../../../ui/Atoms/Dropdown';
import Icon, { IconSize } from '../../../ui/Atoms/Icon';

import { getIcon } from '../../utils/getIcon';

import * as S from './DropdownMenu.styles';

const destructDropdown = ({ link, column }) => {
  const {
    [`dropdown_${column}_link_name`]: name,
    [`dropdown_${column}_description`]: description,
    [`dropdown_${column}_icon`]: icon,
    [`dropdown_${column}_link_color`]: color,
    [`dropdown_${column}_link_url`]: { id, target, url } = {},
  } = link || '';
  return { name, description, icon, color, url, id, target };
};

export const DropdownMenu = ({
  isMobile,
  title,
  content,
  column,
  optionalLabel,
  optionalUrl,
}) => {
  const Component = isMobile ? Collapse : Dropdown;

  const { url: optionalLink, target: optionalTarget } = optionalUrl || '';
  const hasOptionalNav = !!optionalLabel && !!optionalLink;

  return (
    <Component
      appearance={CollapseAppearance.MINIMAL}
      content={() => (
        <S.ContentWrapper>
          {content.map((link, index) => {
            const object = destructDropdown({ link, column });

            if (!object?.name || !object?.url) {
              return null;
            }

            return (
              <S.HeaderLink
                href={object?.url}
                target={object?.target}
                alt={object?.name}
                key={`${link}-${index}`}
              >
                {object?.icon && (
                  <Icon customColor={object?.color} size={IconSize.MICRO}>
                    {getIcon(object?.icon)}
                  </Icon>
                )}
                <S.LinkWrapper>
                  {object?.name && <S.LinkLabel>{object?.name}</S.LinkLabel>}
                  {object?.description && (
                    <S.LinkDescription>{object?.description}</S.LinkDescription>
                  )}
                </S.LinkWrapper>
              </S.HeaderLink>
            );
          })}
          {hasOptionalNav && (
            <S.OptionalButtonWrapper>
              <Button
                appearance={ButtonAppearance.MINIMAL}
                link={optionalLink}
                target={optionalTarget}
              >
                {optionalLabel}
                <FaChevronRight />
              </Button>
            </S.OptionalButtonWrapper>
          )}
        </S.ContentWrapper>
      )}
      main={({ open, isOpen }) => (
        <S.MainContainer isOpen={isOpen}>
          <Button
            appearance={ButtonAppearance.MINIMAL}
            isIconOnRight={true}
            onFocus={open}
          >
            <FaChevronDown />
            {title}
          </Button>
        </S.MainContainer>
      )}
    />
  );
};

DropdownMenu.propTypes = {
  column: PropTypes.number,
  content: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape(propTypesDropdown1),
      PropTypes.shape(propTypesDropdown2),
      PropTypes.shape(propTypesDropdown3),
      PropTypes.shape(propTypesDropdown4),
    ])
  ),
  isMobile: PropTypes.bool,
  optionalLabel: PropTypes.string,
  optionalUrl: PropTypes.shape(propTypesLink),
  title: PropTypes.string,
};

export default DropdownMenu;
